import React, { ElementType, HTMLAttributes, ReactNode } from 'react';

/**
 * `common/Card` (M-UX-2.3, architecture-ux-restructure.md §4.3).
 *
 * Surface-raised + rounded-card + border, per the token layer (M-UX-2.2).
 * `as` allows rendering a `<section>`/`<article>`/etc. instead of a `<div>`
 * without losing the styling contract.
 */
export interface CardProps extends HTMLAttributes<HTMLElement> {
  /** Applies the default padding scale. Set `false` for edge-to-edge content (e.g. tables). */
  padded?: boolean;
  as?: ElementType;
  children?: ReactNode;
}

export function Card({ padded = true, as: Component = 'div', className = '', children, ...rest }: CardProps) {
  return (
    <Component
      className={[
        'bg-surface-raised rounded-card border border-default shadow-[var(--shadow-raised)]',
        padded ? 'p-4 sm:p-6' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </Component>
  );
}

export default Card;
